import Box from '@mui/material/Box'
import { useState } from 'react'
import PlannerInfo from './PlannerInfo'
import Services from '../Services'
import Stepper from '../../atoms/Stepper/Stepper'

export default function PlannerOnboarding({ userDetails, setUserDetails, setRole }) {
	const [step, setStep] = useState(0)

	const renderStep = () => {
		switch (step) {
			case 0:
				return (
					<PlannerInfo
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setStep={setStep}
						setRole={setRole}
					/>
				)
			case 1:
				return (
					<Services
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setStep={setStep}
					/>
				)
			default:
				return null
		}
	}

	return (
		<div>
			{renderStep()}
			<Box
				sx={{
					width: '100%',
					marginTop: '3rem',
					bottom: '30px',
					right: 0,
					'@media (min-width:600px)': { position: 'absolute' },
				}}
			>
				<Stepper totalSteps={2} subSteps={3} activeStep={step + 1} />
			</Box>
		</div>
	)
}
